import React from 'react';
import styles from './index.less';
import { Link, Outlet } from 'umi';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import {
  ConnectState,
  GlobalModelState,
  NodesModelState,
  StorageHomePageModelState,
  UserModelState,
} from '@/models/connect';
import { FServiceAPI, FUtil, FI18n } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import * as AHooks from 'ahooks';
import FLoadingTip from '@/components/FLoadingTip';
import FHeaderNavigation from '@/components/FHeaderNavigation';
import FSimpleBar from '@/components/FSimpleBar';
import FInput_Search from '@/components/FInput_Search';
// import FIntelligentAssistant from '@/components/FIntelligentAssistant';

interface FLayoutProps {
  dispatch: Dispatch;
  global: GlobalModelState;
  storageHomePage: StorageHomePageModelState;
  nodes: NodesModelState;
  user: UserModelState;
}

interface FLayoutStates {
  activeIDs: [string, string];
  searchInput: string;
}

const initState: FLayoutStates = {
  activeIDs: ['', ''],
  searchInput: '',
};

// declare const CozeWebSDK: any;

function FLayout({
  dispatch,
  global,
  storageHomePage,
  nodes,
  user,
}: FLayoutProps) {
  const [$state, $setState] = AHooks.useSetState<FLayoutStates>(initState);

  // AHooks.useMount(() => {
  //   (function () {
  //     new CozeWebSDK.WebChatClient({
  //       /**
  //        * Agent or app settings
  //        * for agent
  //        * @param config.bot_id - Agent ID.
  //        * for app
  //        * @param config.type - To integrate a Coze app, you must set the value to app.
  //        * @param config.isIframe - Whether to use the iframe method to open the chat box
  //        * @param config.appInfo.appId - AI app ID.
  //        * @param config.appInfo.workflowId - Workflow or chatflow ID.
  //        */
  //       config: {
  //         type: 'bot',
  //         bot_id: '7576652645176836136',
  //         isIframe: false,
  //       },
  //       /**
  //        * The auth property is used to configure the authentication method.
  //        * @param type - Authentication method, default type is 'unauth', which means no authentication is required; it is recommended to set it to 'token', which means authentication is done through PAT (Personal Access Token) or OAuth.
  //        * @param token - When the type is set to 'token', you need to configure the PAT (Personal Access Token) or OAuth access key.
  //        * @param onRefreshToken - When the access key expires, a new key can be set as needed.
  //        */
  //       auth: {
  //         type: 'token',
  //         token: 'pat_wyFaeLKXhlVvKwA9o4eStkt3imSJBshVXiAcwAK5V4OYeU2funV4J0OyjfJzwaEZ',
  //         onRefreshToken: async () => 'token',
  //       },
  //       /**
  //        * The userInfo parameter is used to set the display of agent user information in the chat box.
  //        * @param userInfo.id - ID of the agent user.
  //        * @param userInfo.url - URL address of the user's avatar.
  //        * @param userInfo.nickname - Nickname of the agent user.
  //        */
  //       // userInfo: {
  //       // id: 'user',
  //       // id:
  //       //   FUtil.Tool.getUserIDByCookies() !== -1
  //       //     ? (FUtil.Tool.getUserIDByCookies() || '').toString()
  //       //     : 'user-' + Math.random().toString(36).substring(2, 15),
  //       // url: 'https://lf-coze-web-cdn.coze.cn/obj/eden-cn/lm-lgvj/ljhwZthlaukjlkulzlp/coze/coze-logo.png',
  //       // url: 'https://static.freelog.com/static/favicon.ico',
  //       // nickname: 'User',
  //       // nickname:
  //       //   FUtil.Tool.getUserIDByCookies() !== -1
  //       //     ? FUtil.Tool.getUserIDByCookies()
  //       //     : 'User-' + Math.random().toString(36).substring(2, 15),
  //       // },
  //       ui: {
  //         /**
  //          * The ui.base parameter is used to add the overall UI effect of the chat window.
  //          * @param base.icon - Application icon URL.
  //          * @param base.layout - Layout style of the agent chat box window, which can be set as 'pc' or'mobile'.
  //          * @param base.lang - System language of the agent, which can be set as 'en' or 'zh-CN'.
  //          * @param base.zIndex - The z-index of the chat box.
  //          */
  //         base: {
  //           // icon: 'https://lf-coze-web-cdn.coze.cn/obj/eden-cn/lm-lgvj/ljhwZthlaukjlkulzlp/coze/chatsdk-logo.png',
  //           icon: 'https://static.freelog.com/static/favicon.ico',
  //           layout: 'pc',
  //           lang: 'zh',
  //           zIndex: 1000,
  //         },
  //         /**
  //          * Controls whether to display the top title bar and the close button
  //          * @param header.isShow - Whether to display the top title bar.
  //          * @param header.isNeedClose - Whether to display the close button.
  //          */
  //         header: {
  //           isShow: true,
  //           isNeedClose: true,
  //         },
  //         /**
  //          * Controls whether to display the floating ball at the bottom right corner of the page.
  //          */
  //         asstBtn: {
  //           isNeed: true,
  //         },
  //         /**
  //          * The ui.footer parameter is used to add the footer of the chat window.
  //          * @param footer.isShow - Whether to display the bottom copy module.
  //          * @param footer.expressionText - The text information displayed at the bottom.
  //          * @param footer.linkvars - The link copy and link address in the footer.
  //          */
  //         footer: {
  //           isShow: true,
  //           expressionText: 'Powered by ...',
  //         },
  //         /**
  //          * Control the UI and basic capabilities of the chat box.
  //          * @param chatBot.title - The title of the chatbox
  //          * @param chatBot.uploadable - Whether file uploading is supported.
  //          * @param chatBot.width - The width of the agent window on PC is measured in px, default is 460.
  //          * @param chatBot.el - Container for setting the placement of the chat box (Element).
  //          */
  //         chatBot: {
  //           title: 'Freelog 策略生成助手',
  //           uploadable: false,
  //           width: 800,
  //         },
  //       },
  //     });
  //   })();
  // });

  React.useEffect(() => {
    const curRouter = global.routerHistories[global.routerHistories.length - 1];
    // const curRouter = global.routerHistories.at(-1);
    if (!curRouter) {
      return;
    }
    let active: [string, string] = ['', ''];
    if (curRouter.pathname?.startsWith('/dashboard')) {
      active = ['dashboard', ''];
    } else if (curRouter.pathname?.startsWith('/resource/list')) {
      active = ['resource', 'myResource'];
    } else if (curRouter.pathname?.startsWith('/resource/collection')) {
      active = ['resource', 'myCollection'];
    } else if (curRouter.pathname?.startsWith('/resource/collect')) {
      active = ['resource', 'myCollect'];
    } else if (curRouter.pathname?.startsWith('/node/formal/')) {
      const nodeID: string = curRouter.pathname.split('/')[3];
      active = ['node', nodeID];
    } else if (curRouter.pathname?.startsWith('/storage')) {
      active = ['storage', curRouter.query.bucketName || ''];
    } else if (curRouter.pathname?.startsWith('/market')) {
      active = ['discover', 'market'];
    } else if (curRouter.pathname?.startsWith('/examples')) {
      active = ['discover', 'example'];
    }

    $setState({
      activeIDs: active,
    });
  }, [global.routerHistories]);
  const navs = user.info
    ? [
      {
        id: 'dashboard',
        text: FI18n.i18nNext.tAuto('nav_dashboard'),
        href: FUtil.LinkTo.dashboard(),
        emptyItemsTip: undefined,
        items: [],
      },
      {
        id: 'resource',
        text: FI18n.i18nNext.tAuto('nav_ManageResources'),
        href: FUtil.LinkTo.myResources(),
        items: [
          {
            id: 'myResource',
            // text: '我的资源',
            text: FI18n.i18nNext.tAuto('nav_myresources'),
            href: FUtil.LinkTo.myResources(),
          },
          {
            id: 'myCollection',
            // text: '我的合集',
            text: FI18n.i18nNext.tAuto('nav_mycollections'),
            href: FUtil.LinkTo.myCollections(),
          },
          {
            id: 'myCollect',
            // text: '我的收藏',
            text: FI18n.i18nNext.tAuto('nav_mylibrary'),
            href: FUtil.LinkTo.myCollects(),
          },
          {
            id: 'income',
            text:
              // '创作收入',
              FI18n.i18nNext.tAuto('creator_nav_payouts'),
            href: '/resource/income',
          },
          {
            id: 'transaction',
            text:
              // '交易记录',
              FI18n.i18nNext.tAuto('creator_nav_transactionhistory'),
            href: '/resource/transaction',
          },
        ],
      },
      {
        id: 'node',
        text: FI18n.i18nNext.tAuto('nav_ManageNodes'),
        href:
          nodes.list.length === 0
            ? FUtil.LinkTo.nodeCreator()
            : FUtil.LinkTo.nodeManagement({ nodeID: nodes.list[0].nodeId }),
        items: nodes.list.map((n) => ({
          id: n.nodeId.toString(),
          text: n.nodeTitle || n.nodeName,
          href: FUtil.LinkTo.nodeManagement({ nodeID: n.nodeId }),
        })),
        createBtn: {
          href: FUtil.LinkTo.nodeCreator(),
        },
        emptyItemsTip: {
          tipText: '自由创作从Freelog开始',
          btnText: '创建节点',
          btnHref: FUtil.LinkTo.nodeCreator(),
        },
      },
      {
        id: 'storage',
        text: FI18n.i18nNext.tAuto('nav_storage'),
        href: FUtil.LinkTo.storageSpace({
          bucketName:
            storageHomePage.bucketList && storageHomePage.bucketList.length > 0
              ? storageHomePage.bucketList[0].bucketName
              : '',
        }),
        items: (storageHomePage.bucketList || []).map((b) => {
          return {
            id: b.bucketName,
            text: b.bucketName,
            href: FUtil.LinkTo.storageSpace({
              bucketName: b.bucketName,
            }),
          };
        }),
        emptyItemsTip: {
          tipText: '自由创作从Freelog开始',
          btnText: '创建Bucket',
          btnHref: FUtil.LinkTo.storageSpace({
            createBucket: true,
          }),
        },
        createBtn:
          storageHomePage.bucketList && storageHomePage.bucketList.length >= 5
            ? undefined
            : {
              href: FUtil.LinkTo.storageSpace({
                bucketName:
                  storageHomePage.bucketList && storageHomePage.bucketList.length > 0
                    ? $state.activeIDs[0] === 'storage'
                      ? $state.activeIDs[1]
                      : storageHomePage.bucketList[0].bucketName
                    : '',
                createBucket: true,
              }),
            },
      },
    ]
    : [
      {
        id: 'product',
        // text: '产品',
        text: FI18n.i18nNext.tAuto('nav_product'),
        href: FUtil.Format.completeUrlByDomain('www') + FUtil.LinkTo.home(),
        items: [],
      },
    ];

  if (global.globalLoading) {
    return <FLoadingTip height={window.innerHeight} />;
  }

  return (
    <>
      <div className={styles.Layout1}>
        <div className={styles.Header1}>
          <FHeaderNavigation
            logoBtn={{ href: FUtil.LinkTo.dashboard() }}
            showAlphaTest={user.info?.userType === 1}
            showConsoleBabel={!!user.info}
            menu={[
              ...navs,
              {
                id: 'discover',
                text: FI18n.i18nNext.tAuto('nav_explore'),
                href: FUtil.LinkTo.market(),
                items: [
                  {
                    id: 'market',
                    // text: '发现资源',
                    text: FI18n.i18nNext.tAuto('nav_explore_resourcemarket'),
                    href: FUtil.LinkTo.market(),
                  },
                  {
                    id: 'example',
                    // text: '示例节点',
                    text: FI18n.i18nNext.tAuto('nav_explore_nodes'),
                    href: FUtil.LinkTo.exampleNodes(),
                  },
                ],
              },
              {
                id: 'activity',
                text: FI18n.i18nNext.tAuto('nav_events'),
                href: FUtil.Format.completeUrlByDomain('www') + FUtil.LinkTo.activities(),
                items: [],
              },
              {
                id: 'community',
                text: FI18n.i18nNext.tAuto('nav_communitiy'),
                // href: 'https://forum.freelog.com/',
                href: FI18n.i18nNext.tAuto('nav_communitiy_link'),
                target: '_blank',
                items: [],
              },
              {
                id: 'help',
                text: FI18n.i18nNext.tAuto('nav_docs'),
                // href: 'https://freelog3.freelog.com/',
                href: FI18n.i18nNext.tAuto('nav_docs_link'),
                target: '_blank',
                items: [],
              },
            ]}
            activeIDs={$state.activeIDs}
            extra={
              // <FComponentsLib.FInput.FSearch
              <FInput_Search
                size='small'
                placeholder={FI18n.i18nNext.tAuto('market_search_hint')}
                style={{ width: 200 }}
                onPressEnter={() => {
                  self.open(FUtil.LinkTo.globalSearch({ search: $state.searchInput }));
                }}
                value={$state.searchInput}
                onChange={(e) => {
                  $setState({ searchInput: e.target.value });
                }}
              />
            }
            createBtnMenu={[
              {
                id: 'createResource',
                // text: '创建资源',
                text: FI18n.i18nNext.tAuto('nav_CreateNewResource'),
                href: FUtil.LinkTo.resourceCreatorEntry(),
              },
              {
                id: 'createNode',
                // text: '创建节点',
                text: FI18n.i18nNext.tAuto('nav_CreateNewNode'),
                href: FUtil.LinkTo.nodeCreator(),
              },
            ]}
            userPanel={
              user.info
                ? {
                  info: {
                    avatar: user.info.headImage,
                    userName: user.info.username,
                    email: user.info.email,
                    phone: user.info.mobile,
                  },
                  menu: [
                    {
                      // text: '个人中心',
                      text: FI18n.i18nNext.tAuto('nav_UserProfile'),
                      onClick() {
                        window.open(
                          FUtil.Format.completeUrlByDomain('user')
                          // + FUtil.LinkTo.wallet(),
                        );
                      },
                    },
                    {
                      // text: '登出',
                      text: FI18n.i18nNext.tAuto('nav_logout'),
                      async onClick() {
                        await FServiceAPI.User.logout();
                        return window.location.replace(
                          FUtil.Format.completeUrlByDomain('user') + FUtil.LinkTo.login(),
                        );
                      },
                    },
                  ],
                }
                : null
            }
            showHotspotTooltip
          />
        </div>
        <div style={{ zIndex: 1, width: '100vw', height: 'calc(100vh - 70px)' }}>
          <FSimpleBar height={'calc(100vh - 70px)'} id={'layout-content'}>
            <div><Outlet /></div>
          </FSimpleBar>
        </div>
      </div>
      {/* <FIntelligentAssistant /> */}
    </>
  );
}

export default connect(({ global, storageHomePage, nodes, user }: ConnectState) => ({
  global: global,
  storageHomePage: storageHomePage,
  nodes: nodes,
  user: user,
}))(FLayout);
